import { vuexSendingRequestBase } from '@/store/compositionV2/utils/sendingRequest'
import { vuexFileBase } from '@/store/compositionV2/utils/file'
import { SET_STATE_LIST } from '@/store/compositionV2/module/handbook'

import { ContractApi } from '@/api/contracts'
import { ContractProjectApi, ContractStageApi, ContractStatusApi, ContractTypeApi } from '@/api/contracts/handbook'
import { PartnerApi } from '@/api/partner'

import { prepareFormDataId } from '@/utils/form/prepareFormDataId'
import { mapContractorToOption } from '@/utils/entities/contractor'
import { goToPage } from '@/utils/router'
import { showAlertError } from '@/utils/store/alert'
import { debounce } from '@/utils/utils'

const state = () => ({
  api: ContractApi,
  contract: {
    searchProject: '',
    searchContractor: ''
  },
  statusIntexOptionList: [
    { id: 1, name: 'Исполнитель' },
    { id: 2, name: 'Заказчик' }
  ],
  statusOptionList: [],
  projectOptionList: [],
  typeOptionList: [],
  stageOptionList: [],
  contractorOptionList: [],
  debounce: null,
  ...vuexSendingRequestBase.createState(),
  ...vuexFileBase.createState()
})

const mutations = {
  SET_STATE_LIST,
  ...vuexSendingRequestBase.createMutations(),
  ...vuexFileBase.createMutations(),

  SET_DEBOUNCE: (state, debounce) => {
    state.debounce = debounce
  },

  SET_SEARCH_PROJECT: (state, value) => {
    state.contract.searchProject = value || ''
  },
  SET_SEARCH_CONTRACTOR: (state, value) => {
    state.contract.searchContractor = value || ''
  },

  SET_CONTRACTOR_OPTION_LIST: (state, list) => {
    state.contractorOptionList = list.map(mapContractorToOption)
  },

  SET_CONTRACT_UPDATE_INITIAL_STATE: state => {
    state.contract = {
      searchProject: '',
      searchContractor: '',
      files: [],
      deleteFiles: []
    }
  }
}

const actions = {
  ...vuexFileBase.createActions(),

  async contractUpdateSaveInfo ({ state, dispatch, commit }, data) {
    try {
      commit('START_SENDING_REQUEST')

      const preparedData = prepareFormDataId(data, [
        'status_intex',
        'worker',
        'project',
        'stage',
        'status',
        'type',
        'partner'
      ])

      if (state.contract.searchProject) {
        const response = await ContractProjectApi.create({ name: state.contract.searchProject })
        preparedData.project_id = response.data.data.id
      }

      let id = data?.id

      if (!id) {
        const response = await ContractApi.create(preparedData)
        id = response.data.data.id
      } else {
        await ContractApi.update(id, preparedData)
        await dispatch('checkAndDeleteFiles', id)
      }

      await dispatch('processPostAndSortFiles', { id, data: preparedData })

      await goToPage('ContractList')
    } catch (e) {
      showAlertError(e)
    } finally {
      commit('FINISH_SENDING_REQUEST')
    }
  },

  async getContractAllOptions ({ dispatch }) {
    try {
      await Promise.all([
        dispatch('fetchAndSetContractStatuses'),
        dispatch('fetchAndSetContractProjects'),
        dispatch('fetchAndSetContractStages'),
        dispatch('fetchAndSetContractTypes'),
        dispatch('fetchAndSetPartners')
      ])
    } catch (e) {
      showAlertError(e)
    }
  },

  async fetchAndSetContractStatuses ({ commit }) {
    const response = await ContractStatusApi.getAll()
    commit('SET_STATE_LIST', { key: 'statusOptionList', list: response.data.data })
  },
  async fetchAndSetContractProjects ({ commit }, params) {
    const response = await ContractProjectApi.getAll(params)
    commit('SET_STATE_LIST', { key: 'projectOptionList', list: response.data.data })
  },
  async fetchAndSetContractStages ({ commit }) {
    const response = await ContractStageApi.getAll()
    commit('SET_STATE_LIST', { key: 'stageOptionList', list: response.data.data })
  },
  async fetchAndSetContractTypes ({ commit }) {
    const response = await ContractTypeApi.getAll()
    commit('SET_STATE_LIST', { key: 'typeOptionList', list: response.data.data })
  },
  async fetchAndSetPartners ({ commit }, params) {
    const response = await PartnerApi.getAll(params)
    commit('SET_CONTRACTOR_OPTION_LIST', response.data.data)
  },

  getSearchContractContractorsList ({ commit, state, dispatch }, value) {
    commit('SET_SEARCH_CONTRACTOR', value)

    if (!state.debounce) {
      commit(
        'SET_DEBOUNCE',
        debounce(async function () {
          await dispatch('fetchAndSetPartners', {
            'search[all]': state.contract.searchContractor
          })

          commit('SET_DEBOUNCE', null)
        }, 500)
      )

      state.debounce()
    }
  },
  getSearchContractProjectList ({ commit, state, dispatch }, value) {
    commit('SET_SEARCH_PROJECT', value)

    if (!state.debounce) {
      commit(
        'SET_DEBOUNCE',
        debounce(async function () {
          await dispatch('fetchAndSetContractProjects', {
            expand: 'treaties',
            'search[all]': state.contract.searchProject,
            page: 1,
            'per-page': 10
          })

          commit('SET_DEBOUNCE', null)
        }, 500)
      )

      state.debounce()
    }
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
